import { roundMoney } from './format';

export const MIN_QUANTITY = { unidade: 1, peso: 0.01 };

export const isWeightCategory = (tipoDeMedida) => tipoDeMedida === 'peso';

/** Normaliza quantidade/preço e recalcula o total de um item. */
export const buildItem = (item, changes = {}, tipoDeMedida = 'unidade') => {
  const merged = { ...item, ...changes };
  const minimum = MIN_QUANTITY[tipoDeMedida] ?? 1;

  const quantidade = Number.isFinite(Number(merged.quantidade))
    ? Math.max(Number(merged.quantidade), minimum)
    : minimum;
  const preco = Number.isFinite(Number(merged.preco)) ? Math.max(Number(merged.preco), 0) : 0;

  return {
    ...merged,
    quantidade,
    preco,
    total: roundMoney(quantidade * preco),
    checked: Boolean(merged.checked),
  };
};

export const getAllItems = (lista) => [
  ...(lista?.itens || []),
  ...(lista?.categorias || []).flatMap((categoria) => categoria.itens || []),
];

export const sumTotal = (items) =>
  roundMoney(items.reduce((sum, item) => sum + (Number(item.total) || 0), 0));

export const getListaStats = (lista) => {
  const items = getAllItems(lista);
  const completedItems = items.filter((item) => item.checked).length;

  return {
    totalItems: items.length,
    completedItems,
    categoryCount: (lista?.categorias || []).length,
    totalValue: sumTotal(items),
    remainingValue: sumTotal(items.filter((item) => !item.checked)),
    progress: items.length ? Math.round((completedItems / items.length) * 100) : 0,
  };
};

/** Filtra itens por status (todos/marcados/pendentes) e por texto. */
export const filterItems = (items, { status = 'all', search = '' } = {}) => {
  const term = search.trim().toLowerCase();

  return (items || []).filter((item) => {
    if (status === 'checked' && !item.checked) {
      return false;
    }

    if (status === 'unchecked' && item.checked) {
      return false;
    }

    if (term && !(item.nome || '').toLowerCase().includes(term)) {
      return false;
    }

    return true;
  });
};
